<template lang="pug">
  .b2b-table-pending-task
    //- Filtros Tabla Servicios
    b2b-filters-pending-task(:filter-options='options')
    ods-table(
      :data='pendingTask.tableData',
      :default-sort="{prop: 'name', order: 'ascending'}",
      style='width: 100%',
      @sort-change='orderOnServer',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='buyerName',
        :label='$t("pendingtask.pendingtask_entity_table.buyer")',
        :show-overflow-tooltip='true',
        v-if='isShowBuyerPendingTask',
        sortable='')
      ods-table-column(
        prop='centreBuyerCodes',
        :label='$t("pendingtask.pendingtask_entity_table.buyer_centres")',
        :show-overflow-tooltip='true',
        v-if='isShowBuyerCentersPendingTask',
        sortable='')
      ods-table-column(
        prop='sellerName',
        :label='$t("pendingtask.pendingtask_entity_table.seller")',
        :show-overflow-tooltip='true',
        v-if='isShowSellerPendingTask',
        sortable='')
      ods-table-column(
        prop='invoiceNumber',
        :label='$t("pendingtask.pendingtask_entity_table.num_pendingtask")',
        :show-overflow-tooltip='true',
        v-if='isShowNumPendingTask',
        sortable='')
      ods-table-column(
        prop='issueDate',
        :label='$t("pendingtask.pendingtask_entity_table.issue_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateIssuePendingTask',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("pendingtask.pendingtask_entity_table.creation_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateCreationPendingTask',
        :formatter='formatterDate',
        sortable='')
      ods-table-column(
        prop='registerNumber',
        :label='$t("pendingtask.pendingtask_entity_table.register_number")',
        :show-overflow-tooltip='true',
        v-if='isShowRegisterNumberPendingTask',
        sortable='')
      ods-table-column(
        prop='totalExecutableAmount',
        :label='$t("pendingtask.pendingtask_entity_table.import")',
        :show-overflow-tooltip='true',
        v-if='isShowImportPendingTask',
        :formatter='formatterMoney',
        align='right',
        sortable='')
      ods-table-column(
        prop='currencyCode',
        :label='$t("pendingtask.pendingtask_entity_table.divisa")',
        :show-overflow-tooltip='true',
        v-if='isShowCurrencyPendingTask',
        :formatter='formatterCurrency',
        sortable='')
      ods-table-column(
        prop='status',
        :label='$t("pendingtask.pendingtask_entity_table.status")',
        :show-overflow-tooltip='true',
        v-if='isShowStatusPendingTask',
        :formatter='formatterInvoiceStatus',
        sortable='')
        template(slot-scope='scope')
          span(:class="{ 'text-red': canViewStatusColor && scope.row.status && (scope.row.status.toUpperCase() === 'ERROR' || scope.row.status.toUpperCase() === 'REJECTED' || scope.row.status.toUpperCase() === 'REJECTED_REDIGITALIZATION' || scope.row.status.toUpperCase() === 'ANNULLED' || scope.row.status.toUpperCase() === 'CANCELLED') }")
            | {{ formatterInvoiceStatus(scope.row, scope.column) }}
      ods-table-column(
        prop='receptionMethod',
        :label='$t("pendingtask.pendingtask_entity_table.reception_method")',
        :show-overflow-tooltip='true',
        v-if='isShowReceptionMethodPendingTask',
        :formatter='formatterCommunicationMethod',
        sortable='')
      ods-table-column(
        prop='pendingTask',
        align='center',
        :label='$t("pendingtask.pendingtask_entity_table.pendingtask")',
        :show-overflow-tooltip='true',
        v-if='isShowIsPendingTask',
        :formatter='formatterBoolean',
        sortable='')
        template(slot-scope='scope')
          ods-tag(
            v-if='scope.row.pendingTask === null || scope.row.pendingTask === true',
            type='danger'
          ) {{ $t('msg_generics.question.yes') }}
          ods-tag(
            v-if='scope.row.pendingTask !== null && scope.row.pendingTask === false',
            type='success'
          ) {{ $t('msg_generics.question.no') }}
      ods-table-column(
        prop='internalStatus',
        :label='$t("pendingtask.pendingtask_entity_table.internal_status")',
        :show-overflow-tooltip='true',
        v-if='isShowStatusInternalPendingTask',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ formatterTooltipInvoiceStatus(scope.row, scope.column) }}
            span(:class="{ 'text-red': canViewStatusColor && scope.row.internalStatus && (scope.row.internalStatus.toUpperCase() === 'ERROR' || scope.row.internalStatus.toUpperCase() === 'REJECTED' || scope.row.internalStatus.toUpperCase() === 'REJECTED_REDIGITALIZATION' || scope.row.internalStatus.toUpperCase() === 'ANNULLED' || scope.row.internalStatus.toUpperCase() === 'CANCELLED') }")
              div.text-overflow-tooltip
                | {{ formatterInvoiceStatus(scope.row, scope.column) }}

      //- Ocultas por defecto
      ods-table-column(
        width='50')
        template(slot-scope='scope')
          //- Adjuntos
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.attachments') }}
            ods-icon(
              v-if='scope.row.withAttachment!==null && scope.row.withAttachment',
              name='clip',
              size='16')

      //- Columna con QUICK-ACCIONS-BUTTONS
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='120')
        //- Accions emmited
        //- 1 Download Pdf
        template(slot-scope='scope' placement='center')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.downloadPDF') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              icon-position='left'
              @click="downloadPdf(scope.row)")
              ods-icon(name='download', size='16')
          //- 3 Details
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              icon-position='right'
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
          //- PopOver tareas pendientes
          ods-popover(
          placement="bottom-end"
          trigger="hover")
            ul.__quick-accions
              li
                ods-button(
                  icon='ods-icon-download'
                  icon-position='left'
                  @click.native='downloadSignedOriginal(scope.row)' type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('invoices.tooltip.original')}}
              li
                ods-button(
                  v-if="(canAdminIndra || canViewMetadataPendingTask) && scope.row.pathFileMetadata != null"
                  icon='ods-icon-file'
                  icon-position='left'
                  @click.native="handleDownloadMetadata(scope.row)" type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('buttons.btnViewMetadata')}}
              li
                ods-button(
                  v-if='!scope.row.centreBuyerCodes || scope.row.centreBuyerCodes.length === 0' AND 'canCreateCover',
                  icon='ods-icon-plus'
                  icon-position='left'
                  @click.native='handleAddBuyerCenter(scope.row)',
                  type='neutral' style=' padding-left: 0px; padding-right: 0px;')
                  span {{ $t('invoices.tooltip.addBuyerCenter')}}
            ods-button(
              slot="reference",
              icon-position='right'
              type='neutral')
              ods-icon(name='overflow-menu', size='16')
    //- Paginación Tabla
    ods-row.b2b-table-pending-task__pagination(v-if='pendingTask.totalPendingTask > 0')
      ods-col.b2b-table-pending-task__pagination--left(:span='4')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round,
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadCsv')
            | CSV

      ods-col.b2b-table-pending-task__pagination--right(:span='20')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='handleSizeChange',
          @current-change='handleCurrentChangePagination',
          :current-page.sync='currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='20',
          layout='total, sizes, prev, pager, next, slot',
          :total='pendingTask.totalPendingTask')

    //- Recepciones  Seleccionadas
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')
        div(slot='actions')
          ods-button(
            icon='ods-icon-download',
            size='small',
            circle,
            @click.native='downloadPdfMultiple')
            | {{ $t('pendingtask.pendingtask_detail.download_pdfmultiple_buttons') }}
          ods-button(
            icon='ods-icon-download',
            size='small',
            circle,
            @click.native='downloadOriginalInvoiceMultiple')
            | {{ $t('pendingtask.pendingtask_detail.download_originalmultiple_buttons') }}
          ods-button(
            v-if='canCreateCover',
            icon='ods-icon-plus',
            size='small',
            circle,
            @click.native='createRestart')
            | {{ $t('pendingtask.pendingtask_detail.download_createrestar_buttons') }}
          ods-button(
            v-if='!this.projectWithApprovalFlowConfiguration',
            icon='ods-icon-upload',
            size='small',
            circle,
            @click.native='sendToSapInvoices')
            | {{ $t('pendingtask.pendingtask_detail.download_sendinvoice_buttons') }}
          ods-button(
            v-if='!this.projectWithApprovalFlowConfiguration',
            icon='ods-icon-refund',
            size='small',
            circle,
            @click.native='sendStatusPaymentProposal')
            | {{ $t('pendingtask.pendingtask_detail.download_sendstatus_buttons') }}
    ods-dialog(
      ref='dialogAddBuyerCenter',
      :title='$t("invoice_detail.dialog_add_buyer_center.title")',
      :visible.sync='isShowDialogAddBuyerCenter',
      @close='handleCloseDialog'
      width='30%')
      ods-form(
        ref='formAddBuyerCenter',
        :model='dialogAddBuyerCenterForm',
        :rules='rulesAddBuyerCenterForm')
        ods-form-item(
          :label='$t("invoice_detail.dialog_add_buyer_center.centres.label")',
          prop='centreId')
          ods-select(
            :no-match-text='$t("msg_generics.no_match")',
            v-model='dialogAddBuyerCenterForm.centreId',
            filterable,
            :placeholder='$t("invoice_detail.dialog_add_buyer_centre.centres.placeholder")')
            ods-option(
              v-for='option in comboBuyerCenter',
              :key='option.id',
              :label='option.code',
              :value='option.id')
      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='submitAddBuyerCenter("formAddBuyerCenter")')
          | {{ $t('buttons.btnConfirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersPendingTask from '@/views/tareaspendientes/B2bFiltersPendingTask'
import B2bTableMenuPendingTask from '@/views/tareaspendientes/B2bTableMenuPendingTask'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-tareas-pendientes'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-pending-task',
  mixins: [Utils],
  data () {
    return {
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      projectName: '',
      projectId: null,
      // Paginación
      totalResults: 0,
      currentPage: 0,
      projectWithApprovalFlowConfiguration: false,
      isShowDialogAddBuyerCenter: false,
      comboBuyerCenter: [],
      project: null,
      searchType: 'EMITTED',
      dialogAddBuyerCenterForm: {
        centreId: null,
        code: null
      },
      rulesAddBuyerCenterForm: {
        centreId: [
          {
            required: true,
            message: this.$t('invoice_detail.dialog_add_buyer_center.centres.required'),
            trigger: 'change'
          }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'pendingTask',
      'queryPendingTask',
      'optionsFilterCurrency',
      'isShowBuyerPendingTask',
      'isShowBuyerCentersPendingTask',
      'isShowSellerPendingTask',
      'isShowNumPendingTask', // Numero de factura
      'isShowDateIssuePendingTask', // F.emision
      'isShowDateCreationPendingTask', // F.Registro
      'isShowImportPendingTask',
      'isShowCurrencyPendingTask',
      'isShowStatusPendingTask',
      'isShowReceptionMethodPendingTask',
      'isShowIsPendingTask',
      'isShowStatusInternalPendingTask',
      'isShowRegisterNumberPendingTask',
      // Permisos
      'canCreateCover',
      'canAddBuyerCenter',
      'canAdminIndra',
      'canViewStatusColor',
      'canViewMetadataPendingTask',
      'getActiveLang'
    ])
  },

  components: {
    B2bFiltersPendingTask,
    B2bTableMenuPendingTask,
    B2bTableSelectRows
  },

  methods: {
    ...mapActions([
      'getOptionsService',
      'getPendingTask',
      'queryPendingTaskState',
      'downloadInvoicePdfMultiple',
      'downloadMultiInvoiceSignedOriginal',
      'invoiceNoteIdsPendingTaskState',
      'downloadCsvPendingTask',
      'sendToSap',
      // BMG Quick accions
      'downloadPdf',
      'downloadPendingTaskPdf',
      'downloadMetadata',
      'downloadInvoiceSignedOriginalPendingTask',
      'getPaymentProposal',
      'sendPaymentProposal',
      'projectNamependingTaskState',
      'optionsServicesEnabledState',
      'getDataConfigurationCode',
      'getInvoiceNote',
      'getProjectByName',
      'getComboBuyerCenter',
      'addBuyerCenter'
    ]),
    // BMG QUickAccions download PDF
    async downloadPdf (task) {
      console.log('BMG Task    ', task)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })

      try {
        const params = {
          invoiceId: task.id
        }
        const filename = await this.downloadPendingTaskPdf(params)

        this.$notify({
          title: this.$t('pendingtask.pendingtask_detail.notify.download', {
            file: filename
          }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success'
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Download Metadata
    async handleDownloadMetadata (task) {
      console.log('handleDownloadMetadata: ', this.$route.params.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })

      try {
        const params = {
          invoiceNoteId: task.id,
          searchType: this.searchType
        }
        await this.downloadMetadata(params)
        load.close()
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success'
        })
      } catch (error) {
        console.log('handleDownloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Descarga original firmado
    async downloadSignedOriginal (task) {
      console.log('downloadSignedOriginal: ', this.$route.params.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const filename = await this.downloadInvoiceSignedOriginalPendingTask(
          task.id
        )
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success'
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Formatear metodo de recepcion
    formatterCommunicationMethod (row, column) {
      if (row[column.property]) return this.$t('communication_method.' + row[column.property])
      else return ''
    },

    formatterTooltipInvoiceStatus (row, column) {
      if (row.internalMessageStatus && row.internalMessageStatus !== '') return this.formatterInvoiceStatus(row, column) + ' - ' + row.internalMessageStatus
      else return this.formatterInvoiceStatus(row, column)
    },
    // Formatear estado de la tarea pendiente
    formatterInvoiceStatus (row, column) {
      if (row[column.property]) return this.$t('invoice_status.' + row[column.property])
      else return ''
    },

    // Formatear divisa
    formatterCurrency (row, column) {
      if (row[column.property]) {
        return this.$t('currency.' + row[column.property])
      } else {
        return ''
      }
    },

    // Formatear dinero Tabla
    formatterMoney (row, column) {
      const currency = this.optionsFilterCurrency.find(e => e.code === row.currencyCode)
      let negative = false
      let money = this.$n(row[column.property], 'table')
      // le quitamos la parte negativa
      if (money.startsWith('-')) {
        negative = true
        money = money.substring(1)
      }
      // para la longitud de 7 (nnnn,nn)la función $n no le pone el separador de miles
      // lo hacemos manualmente
      if (money.toString().length === 7) {
        const part1 = money.substring(0, 1)
        const part2 = money.substring(1, 7)
        money = part1 + '.' + part2
      }
      // Añadimos la divisa si la tiene
      if (currency && currency.symbol) {
        money += ' ' + currency.symbol
      }
      // si la cantidad era negativa se le pone el menos
      if (negative) {
        money = '-' + money
      }
      return money
    },

    // Formatea un booleano en si no
    formatterBoolean (row) {
      if (row.pendingTask === null || row.pendingTask === true) {
        return this.$t('msg_generics.question.yes')
      } else {
        return this.$t('msg_generics.question.no')
      }
    },

    // Consulta de configuraciones del proyecto
    async getProjectConfigurations () {
      if (this.projectId) {
        const configuraciones = await this.getDataConfigurationCode({
          serviceId: this.projectId,
          dataconfigurationCode: 'APPROVAL_FLOW_BY_LEVELS_AND_USERS'
        })
        if (configuraciones && configuraciones.length > 0) {
          if (configuraciones[0]) {
            this.projectWithApprovalFlowConfiguration = true
          }
        }
      }
      console.log('projectWithApprovalFlowConfiguration: ', this.projectWithApprovalFlowConfiguration)
    },

    // Descargar todos a CSV
    async handleDownloadCsv () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_csv')
      })

      const params = this.queryPendingTask

      try {
        params.activeLang = this.getActiveLang
        const filename = await this.downloadCsvPendingTask(params)

        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success'
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Descarga múltiple de pdf
    async downloadPdfMultiple () {
      const paramsValues = this.multipleSelectionIds.filter(
        (item, index, self) => {
          return index === self.indexOf(item)
        }
      )
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      console.log('downloadPdfMultiple() VALUES ->', paramsValues)
      try {
        const params = {
          invoiceIds: paramsValues
        }

        const filename = await this.downloadInvoicePdfMultiple(params)
        this.$notify({
          title: this.$t(
            'pendingtask.pendingtask_detail.notify.download_multiple',
            {
              file: filename
            }
          ),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success'
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async downloadOriginalInvoiceMultiple () {
      const paramsValues = this.multipleSelectionIds.filter(
        (item, index, self) => {
          return index === self.indexOf(item)
        }
      )
      const load = this.$loading({
        lock: true,
        text: this.$t(
          'pendingtask.pendingtask_detail.download_originalmultiple_buttons'
        )
      })
      console.log('downloadOriginalInvoiceMultiple() VALUES ->', paramsValues)
      try {
        const params = {
          invoiceIds: paramsValues
        }

        const filename = await this.downloadMultiInvoiceSignedOriginal(params)

        this.$notify({
          title: this.$t('pendingtask.pendingtask_detail.notify.download', {
            file: filename
          }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success'
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Redirige a la pantalla de crear cararula y pone facturas en sesion
    async createRestart () {
      const paramsValues = this.multipleSelectionIds.filter(
        (item, index, self) => {
          return index === self.indexOf(item)
        }
      )

      let msgKo = this.$t('pendingtask.createcover.createcover_multiple_ko')
      let flag = false

      this.multipleSelection.forEach(element => {
        if (
          (element.pendingTask === null || element.pendingTask)
        ) {
          // console.log('OK')
        } else {
          msgKo += '\n' + element.invoiceNumber + ','
          flag = true
        }
      })

      if (flag) {
        // Validacion erronea
        try {
          this.$confirm(msgKo.slice(0, -1), {
            confirmButtonText: this.$t('buttons.btnOk'),
            showCancelButton: false,
            center: true,
            iconClass: 'icon-warning'
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        }
      } else {
        // Validacion correcta
        try {
          await this.invoiceNoteIdsPendingTaskState(paramsValues)
          await this.projectNamependingTaskState(this.projectName)
          sessionStorage.setItem('invoiceNumber', '...')
          router.push({
            name: 'create-cover',
            params: {
              projectId: this.projectId
            }
          })
        } catch (error) {
          console.log('createRestart() ->', error)
          this.getNotificationErrorMessage(error)
        }
      }
    },
    checkMaxinvoices (maxSize) {
      return (this.multipleSelection.length > maxSize)
    },
    // Envío de N facturas a SAP
    async sendToSapInvoices () {
      if (this.checkMaxinvoices(20)) {
        this.$confirm(this.$t('pendingtask.pendingtask_detail.sap.maxselected'), {
          confirmButtonText: this.$t('buttons.btnOk'),
          showCancelButton: false,
          center: true,
          iconClass: 'icon-warning'
        })
      } else {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          let msgKo = null
          const invoiceIdsToSend = []

          let invoiceSap = {}
          for (invoiceSap of this.multipleSelection) {
            if (
              !(invoiceSap.pendingTask === null || invoiceSap.pendingTask) &&
          (invoiceSap.sent === null)
            ) {
              msgKo = this.$t('pendingtask.pendingtask_detail.sap.send_multiple_ko', { fact: invoiceSap.invoiceNumber })

              this.$notify({
                title: msgKo,
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                duration: 15000
              })
            } else {
              invoiceIdsToSend.push(invoiceSap.id)
            }
          }
          if (invoiceIdsToSend && invoiceIdsToSend.length > 0) {
            try {
              // Validacion correcta
              const params = {
                invoiceIds: invoiceIdsToSend
              }
              await this.sendToSap(params)
              await this.loadPendingTaskOnDatabase()
            } catch (error) {
              let errorArgList = []
              errorArgList = error.data.errorArgList
              console.log('--> errorArgList ', errorArgList)
              if (errorArgList && errorArgList[0].messageCode !== null) {
                for (let i = 0; i < errorArgList.length; i++) {
                  let fullMessage = errorArgList[i].messageCode
                  if (errorArgList[i].arguments === 'Ok.') {
                    fullMessage = this.$t('pendingtask.pendingtask_detail.sap.send_ok') + ': ' + errorArgList[i].messageCode

                    await this.$notify({
                      title: fullMessage,
                      type: 'success',
                      position: 'top-right',
                      customClass: 'b2b-notification-success',
                      duration: 15000
                    })
                  } else {
                    await this.$notify({
                      title: fullMessage,
                      type: 'error',
                      position: 'top-right',
                      customClass: 'b2b-notification-error',
                      duration: 15000
                    })
                  }
                }
              } else {
                this.getNotificationErrorMessage(error)
              }
            } finally {
              await this.loadPendingTaskOnDatabase()
            }
          }
        } finally {
          load.close()
        }
      }
    },
    // Envío de propuesta de pago
    async sendStatusPaymentProposal () {
      if (this.checkMaxinvoices(20)) {
        this.$confirm(this.$t('pendingtask.pendingtask_detail.sap.maxselected'), {
          confirmButtonText: this.$t('buttons.btnOk'),
          showCancelButton: false,
          center: true,
          iconClass: 'icon-warning'
        })
      } else {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.load_init')
        })
        try {
          let msgKo = null
          const invoiceIdsToSend = []

          let invoicePaymentProposal = {}
          for (invoicePaymentProposal of this.multipleSelection) {
            if (invoicePaymentProposal.id) {
              const paymentProposal = await this.getPaymentProposal(invoicePaymentProposal.id)

              if (paymentProposal.categoryId === null && paymentProposal.description === null &&
          paymentProposal.namePaymentProposal === null && paymentProposal.status === null) {
                msgKo = this.$t('pendingtask.createcover.noCoverPP') + invoicePaymentProposal.invoiceNumber + this.$t('pendingtask.createcover.noSendCoverPP')

                this.$notify({
                  title: msgKo,
                  type: 'error',
                  position: 'top-right',
                  customClass: 'b2b-notification-success',
                  duration: 15000
                })
              } else {
                invoiceIdsToSend.push(invoicePaymentProposal.id)
              }
            }
          }
          if (invoiceIdsToSend && invoiceIdsToSend.length > 0) {
            try {
              // Validacion correcta
              const params = {
                invoiceIds: invoiceIdsToSend
              }

              await this.sendPaymentProposal(params)
              await this.loadPendingTaskOnDatabase()
            } catch (error) {
              let errorArgList = []
              errorArgList = error.data.errorArgList
              console.log('--> errorArgList ', errorArgList)
              if (errorArgList && errorArgList[0].messageCode !== null) {
                for (let i = 0; i < errorArgList.length; i++) {
                  let fullMessage = errorArgList[i].messageCode
                  if (errorArgList[i].arguments === 'OK.') {
                    fullMessage = this.$t('pendingtask.createcover.cover.send_multiple_ko') + errorArgList[i].messageCode

                    await this.$notify({
                      title: fullMessage,
                      type: 'success',
                      position: 'top-right',
                      customClass: 'b2b-notification-success',
                      duration: 15000
                    })
                  } else {
                    await this.$notify({
                      title: fullMessage,
                      type: 'error',
                      position: 'top-right',
                      customClass: 'b2b-notification-error',
                      duration: 15000
                    })
                  }
                }
              } else {
                this.getNotificationErrorMessage(error)
              }
            } finally {
              await this.loadPendingTaskOnDatabase()
            }
          }
        } finally {
          load.close()
        }
      }
    },

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      try {
        let stringSort = ''
        const dataQuery = {
          query: {}
        }

        if (order === 'descending') {
          order = 'DESC'
        } else if (order === 'ascending') {
          order = 'ASC'
        } else {
          order = 'ASC'
        }

        if (!prop) {
          prop = 'creationDateTime' // antes 'inputDateTime'
        } else {
          switch (prop) {
            case 'buyerName':
              prop = 'partyByIdBuyer.tradeName'
              break
            case 'sellerName':
              prop = 'partyByIdSeller.tradeName'
              break
            case 'centreBuyerCodes':
              prop = 'codeCentresBuyer'
              break
            case 'centreBuyer':
              prop = 'centreBuyer.centreCode'
              break
            case 'centreBuyerDeliveryPoint':
              prop = 'centreDeliveryPoint.centreCode'
              break
            case 'centreBuyerInvoicee':
              prop = 'centreInvoicee.centreCode'
              break
            case 'centreSellerCodes':
              prop = 'centreSeller.centreCode'
              break
            case 'status':
              prop = 'statusDocumentByIdStatus.status'
              break
            case 'receptionMethod':
              prop = 'communicationsMethodByIdReceptCommMethod.name'
              break
            case 'internalStatus':
              prop = 'statusDocumentByInternalStatus.status'
              break
          }
        }

        stringSort = prop + ',' + order
        this.queryPendingTask.sort = stringSort
        await this.queryPendingTaskState(this.queryPendingTask)
        dataQuery.query = this.queryPendingTask
        const response = await this.getPendingTask(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },
    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
      if (this.multipleSelection.length > 0) {
        this.projectName = this.multipleSelection[0].projectName
        this.projectId = this.multipleSelection[0].idProject
      }
    },

    /* Ir al detalle */
    async handleGoDetail (invoiceId) {
      const factura = []
      factura.push(this.currentRow.id)
      // Guardamos el id la factura en session para poder recuperarlo en la creación de carartulas
      await this.invoiceNoteIdsPendingTaskState(factura)
      sessionStorage.setItem('invoiceNumber', this.currentRow.invoiceNumber)
      router.push({
        name: 'tareaspendientes-detail',
        params: {
          invoiceId: this.currentRow.id,
          invoiceNumber: this.currentRow.invoiceNumber
        }
      })
    },

    async handleAddBuyerCenter (row) {
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.load.collecting_buyer_center')
      })
      try {
        this.handleCellMouseEnter(row)
        this.invoiceId = row.id
        const request = {
          invoiceId: row.id
        }
        this.comboBuyerCenter = await this.getComboBuyerCenter(request)
        // Obtener combo de centros de comprador
        this.obtainCentreId()

        this.isShowDialogAddBuyerCenter = true
      } finally {
        load.close()
      }
    },
    obtainCentreId () {
      this.comboBuyerCenter.forEach(element => {
        this.dialogAddBuyerCenterForm.centreId = element.id
        this.dialogAddBuyerCenterForm.code = element.code
      })
    },
    submitAddBuyerCenter (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('invoice_detail.load.add_buyer_center')
          })
          try {
            let params = {}
            const tittleConfirm = this.$t('invoice_detail.notification.add_buyer_center_ok')

            console.log('submitAddBuyerCenter: ', this.dialogAddBuyerCenterForm)
            params = {
              invoiceId: this.invoiceId,
              buyerCenterId: this.dialogAddBuyerCenterForm.centreId
            }
            await this.addBuyerCenter(params)
            this.$notify({
              title: tittleConfirm,
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
            this.$refs[formName].resetFields()
            this.isShowDialogAddBuyerCenter = false
          } catch (error) {
            console.log('submitResendInvoice CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs[formName].resetFields()
            this.isShowDialogResendInvoice = false
          } finally {
            await this.loadPendingTaskOnDatabase()
            load.close()
          }
        } else {
          console.log('submitResendInvoice INVALID: ', this.dialogResendInvoiceForm)
          return false
        }
      })
    },
    handleCloseDialog () {
      this.isShowDialogAddBuyerCenter = false
      this.$refs.formAddBuyerCenter.resetFields()
    },
    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuPendingTask />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })

      try {
        const dataQuery = {
          query: {
            searchType: 'EMITTED'
          }
        }

        this.queryPendingTask.size = val
        await this.queryPendingTaskState(this.queryPendingTask)
        dataQuery.query = this.queryPendingTask
        const response = await this.getPendingTask(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      try {
        const dataQuery = {
          query: {}
        }

        this.queryPendingTask.page = val - 1
        await this.queryPendingTaskState(this.queryPendingTask)
        dataQuery.query = this.queryPendingTask

        const response = await this.getPendingTask(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async loadPendingTaskOnDatabase () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })

      try {
        const dataQuery = { query: {} }
        this.options = filters.filters

        const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC', hasPendingTask: true }
        const optionsFilterService = await this.getOptionsService(dataQueryProj)
        await this.optionsServicesEnabledState(optionsFilterService)

        if (optionsFilterService.length === 1) {
          this.queryPendingTask.projectId = optionsFilterService[0].id
          this.projectId = optionsFilterService[0].id
        }
        dataQuery.query = this.queryPendingTask
        const response = await this.getPendingTask(dataQuery)
        this.totalResults = response.data.totalElements
        this.currentPage = response.data.number + 1
      } catch (error) {
        console.log('getPendingTask CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          if (errorSms === 'NO_PENDING_TASK_STATUS') {
            errorSms = this.$t('msg_generics.no_pending_task_status')
          }
          break
        case 500:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error, 15000)
    }
  },

  async created () {
    await this.loadPendingTaskOnDatabase()
    await this.getProjectConfigurations()
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-pending-task {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      .ods-dropdown{
        padding-left: 0px;
        padding-right: 0px;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          // ajustamos solo el icno de ajuste al centro
          display: flex;
          justify-content: center;
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row{
      .ods-button {
        padding: rem(0) rem(5);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
<style lang="scss">
  .text-red {
    color: #ff0000;
  }
</style>
